import { EpicRefined } from 'interfaces/middleware'
import { AdvisorPublicActions, GetPublicAdvisorReviewsAction } from 'components/features/coaching/advisorStore/actions/publicAdvisorActions'
import { filterRequest } from 'rxOperators/filterRequestOfType'
import { mergeMap, map } from 'rxjs/operators'
import { GET_ADVISOR_PUBLIC_REVIEWS_URL } from 'interfaces/ajax'
import { ajaxCatch, AjaxCatchExtraActions } from 'rxOperators/ajaxCatch'
import { of } from 'rxjs'
import find from 'lodash/find'


export const getAdvisorReviewsEpic: EpicRefined<AdvisorPublicActions | AjaxCatchExtraActions> = (action$, store, { get }) => action$.pipe(
  filterRequest(GetPublicAdvisorReviewsAction.type),
  mergeMap((action) => {
    const { reviewsPagination } = store.getState().data.advisors
    const prevRequest = find(reviewsPagination, action.payload.params)

    const request$ = (() => {
      if (prevRequest?.next) {
        const { searchParams } = new URL(prevRequest.next)
        const query = Object.fromEntries(searchParams.entries())
        return get(GET_ADVISOR_PUBLIC_REVIEWS_URL, query as any)
      }

      return get(GET_ADVISOR_PUBLIC_REVIEWS_URL, {
        ...action.payload.params,
        ordering: '-created',
      })
    })()

    return request$.pipe(
      map(({ response }) => action.success(response)),
      ajaxCatch((error) => of(action.fail({ errorCode: error.status }))),
    )
  }),
)
